import React from "react";

interface StopPropagateDivProps extends React.HTMLAttributes<HTMLDivElement> {}

const StopPropagateDiv: React.FC<StopPropagateDivProps> = ({
    children,
    onClick,
    ...props
}) => {
    const stopPropagation = (event: React.SyntheticEvent) => {
        event.stopPropagation();
    };

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        stopPropagation(event);
        onClick?.(event);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        stopPropagation(event);
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            const syntheticClick = new MouseEvent("click", {
                bubbles: true,
                cancelable: true,
                view: window,
            });
            event.currentTarget.dispatchEvent(syntheticClick);
        }
    };

    return (
        <div
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
            {...props}
        >
            {children}
        </div>
    );
};

export default StopPropagateDiv;
